import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import i18n from 'i18next'
import { parseHtmlForReact } from '../../helpers'

@observer
class PriorityOptionList extends Component {
    componentDidMount() {
        if (this.props.setHeight) {
            const height = this.divElement.offsetHeight
            this.props.setHeight(height)
        }
    }

    getOptions = () => {
        const {
            options, store, question, type, priorities, handleClick,
        } = this.props

        const orderedOptions = [...options]

        orderedOptions.sort((a, b) => priorities.indexOf(a.id) - priorities.indexOf(b.id))


        return orderedOptions.map((option, index) => {
            if (priorities.includes(option.id) && type === 'options') {
                return null
            } if (!priorities.includes(option.id) && type === 'answers') {
                return null
            }

            const optionVar = type === 'answers' ? option.id : option

            const answerIndex = priorities.indexOf(option.id)

            return <Draggable key={option.id} draggableId={option.id} index={answerIndex > -1 ? answerIndex : index} id={option.id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        onClick={() => handleClick(optionVar)}
                    >
                        <div
                            className='draggableOption'
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                            {parseHtmlForReact(store.getOptionTitle(option, question))}
                            {answerIndex > -1 && <span className="desktopPriority">{answerIndex + 1}</span>}
                        </div>
                        <div className='draggableOptionSpacer'></div>
                    </div>
                )}
            </Draggable>
        })
    }

    renderPlaceholder = () => {
        const { type, priorities } = this.props
        if (priorities.filter(p => p === 0 || p).length || type === 'options') return null
        return (<div className="placeHolder">{i18n.t('questions.priority.placeholder')}</div>)
    }

    render() {
        const { type, priorities } = this.props
        return (
            <div ref={ (divElement) => { this.divElement = divElement } } style={this.props.height ? { minHeight: this.props.height } : {}}>
                <Droppable droppableId={`droppable_${type}`} type='priorities'>
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={this.props.height ? { minHeight: this.props.height } : {}}
                        >
                            {this.getOptions()}
                            {this.renderPlaceholder()}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        )
    }
}

export default PriorityOptionList
